export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'es',
    messages: {
        es: {
            "DestinationMarket": "Mercado de Destino",
            "Make": "Marca",
            "Manufacturer": "Fabricante",
            "Model": "Modelo",
            "ModelYear": "Año del Modelo",
            "PlantCity": "Ciudad de Producción",
            "Series": "Serie",
            "Trim": "Versión",
            "VehicleType": "Tipo de Vehículo",
            "PlantCountry": "País de Producción",
            "PlantCompanyName": "Nombre de la Compañía Productora",
            "PlantState": "Estado de Producción",
            "Trim2": "Versión Alternativa",
            "Series2": "Serie Alternativa",
            "Note": "Nota",
            "BasePrice": "Precio Base",
            "NonLandUse": "Uso No Terrestre",
            "EngineCylinders": "Cilindros del Motor",
            "DisplacementCC": "Cilindrada (CC)",
            "DisplacementCI": "Cilindrada (CI)",
            "DisplacementL": "Cilindrada (L)",
            "EngineCycles": "Ciclos del Motor",
            "EngineModel": "Modelo del Motor",
            "EngineHP": "Potencia del Motor (HP)",
            "FuelTypePrimary": "Tipo de Combustible Principal",
            "ValveTrainDesign": "Diseño del Tren de Válvulas",
            "EngineConfiguration": "Configuración del Motor",
            "FuelTypeSecondary": "Tipo de Combustible Secundario",
            "FuelInjectionType": "Tipo de Inyección de Combustible",
            "EngineHP_to": "Potencia Máxima del Motor (HP)",
            "CoolingType": "Tipo de Refrigeración",
            "ElectrificationLevel": "Nivel de Electrificación",
            "OtherEngineInfo": "Otra Información del Motor",
            "Turbo": "Turbo",
            "TopSpeedMPH": "Velocidad Máxima (MPH)",
            "EngineManufacturer": "Fabricante del Motor",
            "DriveType": "Tipo de Tracción",
            "Axles": "Ejes",
            "AxleConfiguration": "Configuración del Eje",
            "TransmissionStyle": "Estilo de Transmisión",
            "TransmissionSpeeds": "Velocidades de la Transmisión",
            "BrakeSystemType": "Tipo de Sistema de Frenos",
            "BrakeSystemDescription": "Descripción del Sistema de Frenos",
            "BatteryInfo": "Información de la Batería",
            "BatteryType": "Tipo de Batería",
            "BatteryCells": "Celdas de la Batería",
            "BatteryA": "Amperaje de la Batería",
            "BatteryA_to": "Amperaje Máximo de la Batería",
            "BatteryV": "Voltaje de la Batería",
            "BatteryV_to": "Voltaje Máximo de la Batería",
            "BatteryKWh": "Capacidad de la Batería (kWh)",
            "BatteryKWh_to": "Capacidad Máxima de la Batería (kWh)",
            "BatteryModules": "Módulos de la Batería",
            "BatteryPacks": "Packs de la Batería",
            "EVDriveUnit": "Unidad de Conducción Eléctrica",
            "BodyClass": "Clase de Carrocería",
            "Doors": "Puertas",
            "Windows": "Ventanas",
            "WheelBaseType": "Tipo de Distancia entre Ejes",
            "TrackWidth": "Ancho de Vía",
            "BedType": "Tipo de Cama",
            "BodyCabType": "Tipo de Cabina",
            "NumberOfWheels": "Número de Ruedas",
            "WheelSizeFrontInches": "Tamaño de Rueda Delantera (Pulgadas)",
            "WheelSizeRearInches": "Tamaño de Rueda Trasera (Pulgadas)",
            "NumberOfSeats": "Número de Asientos",
            "NumberOfSeatRows": "Número de Filas de Asientos",
            "EntertainmentSystem": "Sistema de Entretenimiento",
            "SteeringLocation": "Ubicación del Volante",
            "GrossVehicleWeightRatingFrom": "Peso Bruto del Vehículo Desde",
            "CurbWeightPounds": "Peso en Vacío (Libras)",
            "WheelBaseInchesFrom": "Distancia entre Ejes Desde (Pulgadas)",
            "WheelBaseInchesTo": "Distancia entre Ejes Hasta (Pulgadas)",
            "CurtainAirBagLocations": "Ubicación de Bolsas de Aire Laterales",
            "FrontAirBagLocations": "Ubicación de Bolsas de Aire Frontales",
            "SideAirBagLocations": "Ubicación de Bolsas de Aire Laterales",
            "Pretensioner": "Pretensor",
            "SeatBeltType": "Tipo de Cinturón de Seguridad",
            "OtherRestraintSystemInfo": "Otra Información del Sistema de Retención",
            "AutomaticCrashNotification": "Notificación Automática de Choques",
            "DaytimeRunningLight": "Luz Diurna",
            "HeadlampLightSource": "Fuente de Luz del Faro",
            "SemiautomaticHeadlampBeamSwitching": "Cambio Semiautomático de Luz de Faro",
            "CrashImminentBraking": "Frenado Inminente por Choque",
            "ForwardCollisionWarning": "Advertencia de Colisión Frontal",
            "DynamicBrakeSupport": "Soporte Dinámico de Frenos",
            "PedestrianAutomaticEmergencyBraking": "Frenado de Emergencia Automático para Peatones",
            "BlindSpotWarning": "Advertencia de Punto Ciego",
            "LaneDepartureWarning": "Advertencia de Salida de Carril",
            "LaneKeepingAssistance": "Asistencia para Mantener el Carril",
            "BlindSpotIntervention": "Intervención en Punto Ciego",
            "LaneCenteringAssistance": "Asistencia para Centrado en Carril",
            "BackupCamera": "Cámara de Reversa",
            "ParkingAssist": "Asistencia de Estacionamiento",
            "RearCrossTrafficAlert": "Alerta de Tráfico Cruzado Trasero",
            "RearAutomaticEmergencyBraking": "Frenado Automático de Emergencia Trasero",
            "NCSABodyType": "Tipo de Carrocería NCSA",
            "NCSAMake": "Marca NCSA",
            "NCSAModel": "Modelo NCSA",
            "NCSANote": "Nota NCSA",
            blog: 'Blog',
            NEW: 'Nuevo',
            USED: 'Usado',
            login: 'Iniciar Sesión',
            register: 'Registrar',
            profile: 'Mi Perfil',
            home: 'Inicio',
            real_estates: 'Bienes Raíces',
            cars: 'Carros',
            search: {
                realstates: 'Buscar Municipio, Barrio o Zip',
                cars: 'Buscar Marca o Modelo',
                btn: 'Buscar'

            },
            rs: {
                populars: {
                    title: '<span class=\'text-primary\'>Casas</span> Destacadas',
                    description: 'Propiedades destacadas: oportunidades únicas que ofrecen calidad, ubicación y valor.',
                    button_description: 'Ver mas propiedades'
                }
            },
            pc: {
                populars: {
                    title: '<span class =\'text-primary text-bold\'>Carros</span> destacados',
                    description: 'Automóviles destacados: Encuentra justo lo que necesitas',
                    button_description: 'Ver más Automóviles'
                }
            },
            footer: {
                description: 'Compralovendelo es una plataforma en línea que conecta compradores y vendedores de automóviles, ofreciendo una experiencia de compra y venta eficiente y segura.',
                contact: 'Contacto',
                links: 'Enlaces Rápidos',
                about_us: 'Acerca de Nosotros',
                contact_us: 'Contáctanos',
                faq: 'FAQ',
                policy: 'Políticas de Privacidad',
                termsAndConditions: 'Términos y Condiciones',
                recources: 'Recursos',
                blog: 'Blog',
                guides: 'Guías',
                help: 'Ayuda',
                follow_us: 'Síguenos',
                rights: '© 2024 Compralovendelo. Todos los derechos reservados.'
            },
            about_us: {
                header: {
                    title: 'Acerca de Nosotros',
                    description: 'Tu directorio online para compra y venta de carros'
                },
                herostc: {
                    title: 'Impulsando tu experiencia de compra y venta',
                    description1: 'Compralovendelo es un directorio en línea especializado en carros.\
                    Su propósito es conectar de manera eficiente a compradores y vendedores, ofreciendo una plataforma segura y fácil de usar.',
                    description2: 'Compralovendelo se distingue por su enfoque en la innovación y la transparencia, proporcionando\
                    herramientas avanzadas para el análisis de datos, colaboración en equipo, generación de informes personalizados\
                    e integraciones con otras herramientas populares. La visión de Compralovendelo es crear un mercado accesible\
                    y eficiente, mientras que su misión se centra en ofrecer una experiencia de usuario impecable y de confianza\
                    para todas las transacciones de alto valor.',
                    btn: 'Comienza Ahora'
                },
                featurestc: {
                    title: 'Explora nuestras características',
                    subtitle1: 'Análisis de Datos',
                    subtitle2: 'Colaboración',
                    subtitle3: 'Informes Personalizados',
                    subtitle4: 'Integraciones',
                    description1: 'Obtén información detallada sobre tus listados y clientes.',
                    description2: 'Trabaja con tu equipo en tiempo real, desde cualquier lugar.',
                    description3: 'Genera informes detallados para tomar decisiones informadas.',
                    description4: 'Integra fácilmente con otras herramientas populares.',
                },
                testimonialsstc: {
                    title: 'Lo que dicen nuestros clientes',
                    comment1: '"Compralovendelo ha revolucionado nuestra forma de comprar y vender carros. La plataforma es fácil de usar y muy eficiente."',
                    comment2: '"Gracias a Compralovendelo, encontramos el auto perfecto. La variedad de opciones y la seguridad en las transacciones nos dieron mucha confianza."',
                    comment3: '"En Compralovendelo, siempre encuentro herramientas con las que puedo mejorar mis ventas."',
                    user1: '- Juan Pérez, Inversionista',
                    user2: '- María López, Compradora',
                    user3: '- Carlos González, Gerente',
                },
                faqstc: {
                    title: 'Preguntas Frecuentes',
                    question1: '¿Qué es Compralovendelo?',
                    question2: '¿Cómo funciona Compralovendelo?',
                    question3: '¿Es seguro usar Compralovendelo?',
                    answer1: 'Compralovendelo es un directorio online para carros, que conecta compradores y vendedores de manera eficiente y segura.',
                    answer2: 'Nuestra plataforma permite a los usuarios listar sus carros, buscar opciones disponibles, y realizar transacciones seguras.',
                    answer3: 'Sí, priorizamos la seguridad de nuestros usuarios con verificaciones de listados y transacciones seguras.'
                }
            },
            contact_us: {
                header: {
                    title: 'Contactanos',
                    description: 'Si tienes alguna pregunta, no dudes en ponerte en contacto con nosotros. Estamos aquí para ayudarte.'
                },
                form: {
                    name: 'Nombre',
                    email: 'Correo Electrónico',
                    subject: 'Asunto',
                    message: 'Mensaje',
                    btn: 'Enviar'
                }
            },
            faq: {
                header: {
                    title: 'Preguntas Frecuentes',
                    description: 'Estamos aquí para responder a tus dudas.'
                },
                description: 'Descubre la gama completa de características y servicios que ofrecemos y cómo utilizarlos.',
                morequestion: '¿Tienes más preguntas? Contacta a nuestro equipo de soporte con cualquier consulta que puedas tener.',
                contact_us: 'Contactamos'

            },
            white: 'Blanco',
            black: 'Negro',
            gray: 'Gris',
            silver: 'Plateado',
            red: 'Rojo',
            blue: 'Azul',
            green: 'Verde',
            yellow: 'Amarillo',
            orange: 'Naranja',
            purple: 'Púrpura',
            pink: 'Rosa',
            brown: 'Marrón',
            bronze: 'Bronce',
            beige: 'Beige',
        },
        en: {
            "DestinationMarket": "Destination Market",
            "Make": "Make",
            "Manufacturer": "Manufacturer",
            "Model": "Model",
            "ModelYear": "Model Year",
            "PlantCity": "Plant City",
            "Series": "Series",
            "Trim": "Trim",
            "VehicleType": "Vehicle Type",
            "PlantCountry": "Plant Country",
            "PlantCompanyName": "Plant Company Name",
            "PlantState": "Plant State",
            "Trim2": "Alternate Trim",
            "Series2": "Alternate Series",
            "Note": "Note",
            "BasePrice": "Base Price",
            "NonLandUse": "Non-Land Use",
            "EngineCylinders": "Engine Cylinders",
            "DisplacementCC": "Displacement (CC)",
            "DisplacementCI": "Displacement (CI)",
            "DisplacementL": "Displacement (L)",
            "EngineCycles": "Engine Cycles",
            "EngineModel": "Engine Model",
            "EngineHP": "Engine Horsepower (HP)",
            "FuelTypePrimary": "Primary Fuel Type",
            "ValveTrainDesign": "Valve Train Design",
            "EngineConfiguration": "Engine Configuration",
            "FuelTypeSecondary": "Secondary Fuel Type",
            "FuelInjectionType": "Fuel Injection Type",
            "EngineHP_to": "Maximum Engine Horsepower (HP)",
            "CoolingType": "Cooling Type",
            "ElectrificationLevel": "Electrification Level",
            "OtherEngineInfo": "Other Engine Information",
            "Turbo": "Turbo",
            "TopSpeedMPH": "Top Speed (MPH)",
            "EngineManufacturer": "Engine Manufacturer",
            "DriveType": "Drive Type",
            "Axles": "Axles",
            "AxleConfiguration": "Axle Configuration",
            "TransmissionStyle": "Transmission Style",
            "TransmissionSpeeds": "Transmission Speeds",
            "BrakeSystemType": "Brake System Type",
            "BrakeSystemDescription": "Brake System Description",
            "BatteryInfo": "Battery Information",
            "BatteryType": "Battery Type",
            "BatteryCells": "Battery Cells",
            "BatteryA": "Battery Amperage",
            "BatteryA_to": "Maximum Battery Amperage",
            "BatteryV": "Battery Voltage",
            "BatteryV_to": "Maximum Battery Voltage",
            "BatteryKWh": "Battery Capacity (kWh)",
            "BatteryKWh_to": "Maximum Battery Capacity (kWh)",
            "BatteryModules": "Battery Modules",
            "BatteryPacks": "Battery Packs",
            "EVDriveUnit": "Electric Drive Unit",
            "BodyClass": "Body Class",
            "Doors": "Doors",
            "Windows": "Windows",
            "WheelBaseType": "Wheelbase Type",
            "TrackWidth": "Track Width",
            "BedType": "Bed Type",
            "BodyCabType": "Cabin Type",
            "NumberOfWheels": "Number of Wheels",
            "WheelSizeFrontInches": "Front Wheel Size (Inches)",
            "WheelSizeRearInches": "Rear Wheel Size (Inches)",
            "NumberOfSeats": "Number of Seats",
            "NumberOfSeatRows": "Number of Seat Rows",
            "EntertainmentSystem": "Entertainment System",
            "SteeringLocation": "Steering Location",
            "GrossVehicleWeightRatingFrom": "Gross Vehicle Weight Rating From",
            "CurbWeightPounds": "Curb Weight (Pounds)",
            "WheelBaseInchesFrom": "Wheelbase From (Inches)",
            "WheelBaseInchesTo": "Wheelbase To (Inches)",
            "CurtainAirBagLocations": "Curtain Airbag Locations",
            "FrontAirBagLocations": "Front Airbag Locations",
            "SideAirBagLocations": "Side Airbag Locations",
            "Pretensioner": "Pretensioner",
            "SeatBeltType": "Seat Belt Type",
            "OtherRestraintSystemInfo": "Other Restraint System Information",
            "AutomaticCrashNotification": "Automatic Crash Notification",
            "DaytimeRunningLight": "Daytime Running Light",
            "HeadlampLightSource": "Headlamp Light Source",
            "SemiautomaticHeadlampBeamSwitching": "Semiautomatic Headlamp Beam Switching",
            "CrashImminentBraking": "Crash Imminent Braking",
            "ForwardCollisionWarning": "Forward Collision Warning",
            "DynamicBrakeSupport": "Dynamic Brake Support",
            "PedestrianAutomaticEmergencyBraking": "Pedestrian Automatic Emergency Braking",
            "BlindSpotWarning": "Blind Spot Warning",
            "LaneDepartureWarning": "Lane Departure Warning",
            "LaneKeepingAssistance": "Lane Keeping Assistance",
            "BlindSpotIntervention": "Blind Spot Intervention",
            "LaneCenteringAssistance": "Lane Centering Assistance",
            "BackupCamera": "Backup Camera",
            "ParkingAssist": "Parking Assist",
            "RearCrossTrafficAlert": "Rear Cross Traffic Alert",
            "RearAutomaticEmergencyBraking": "Rear Automatic Emergency Braking",
            "NCSABodyType": "NCSA Body Type",
            "NCSAMake": "NCSA Make",
            "NCSAModel": "NCSA Model",
            "NCSANote": "NCSA Note",
            blog: 'Blog',
            NEW: 'New',
            USED: 'Used',
            login: 'Sign In',
            register: 'Sign Up',
            profile: 'My Profile',
            home: 'Home',
            real_estates: 'Real Estate',
            cars: 'Cars',
            search: {
                realstates: 'Search Municipality, Neighborhood, or Zip Code',
                cars: 'Search Brand or Model',
                btn: 'Search'
            },
            rs: {
                populars: {
                    title: 'Visit our <span class=\'text-primary\'>Featured Homes</span>',
                    description: 'Featured properties: unique opportunities offering quality, location, and value.',
                    button_description: 'See more properties'
                }
            },
            pc: {
                populars: {
                    title: 'Check out the lastes <span class =\'text-primary text-bold\'>Cars</span>',
                    description: 'Featured cars: Find just what you need',
                    button_description: 'View more cars'
                }
            },
            footer: {
                description: 'Compralovendelo is an online platform that connects buyers and sellers of real estate, cars, and yachts, offering an efficient and secure buying and selling experience',
                contact: 'Contact',
                links: 'Quick Links',
                about_us: 'About Us',
                contact_us: 'Contact Us',
                faq: 'FAQ',
                policy: 'Privacy Policy',
                termsAndConditions: 'Terms and Conditions',
                recources: 'Resources',
                blog: 'Blog',
                guides: 'Guides',
                help: 'Help',
                follow_us: 'Follow Us',
                rights: '© 2024 Compralovendelo. All rights reserved.'
            },
            about_us: {
                header: {
                    title: 'About Compralovendelo',
                    description: 'Your online directory for real estate, cars, and yachts'
                },
                herostc: {
                    title: 'Enhancing your buying and selling experience.',
                    description1: 'Compralovendelo is an online directory specializing in real estate, automobiles, yachts, and more. Its purpose is to efficiently connect buyers and sellers, offering a secure and user-friendly platform.',
                    description2: 'Compralovendelo stands out for its focus on innovation and transparency, providing advanced tools for data analysis, team collaboration, custom report generation, and integration with other popular tools.\
                    Compralovendelo is vision is to create an accessible and efficient marketplace, while its mission is to provide a seamless and trustworthy user experience for all high-value transactions.',
                    btn: 'Get Started Now'
                },
                featurestc: {
                    title: 'Explore our features',
                    subtitle1: 'Data Analysis',
                    subtitle2: 'Collaboration',
                    subtitle3: 'Custom Reports',
                    subtitle4: 'Integrations',
                    description1: 'Gain detailed insights into your listings and clients.',
                    description2: 'Work with your team in real-time, from anywhere.',
                    description3: 'Generate detailed reports to make informed decisions.',
                    description4: 'Easily integrate with other popular tools.',
                },
                testimonialsstc: {
                    title: 'What Our Customers Say',
                    comment1: '"Compralovendelo has revolutionized our way of buying and selling real estate. The platform is easy to use and very efficient."',
                    comment2: '"Thanks to Compralovendelo, we found the perfect car. The variety of options and transaction security gave us a lot of confidence."',
                    comment3: '"The best platform for yachts we have used. The analysis tools and custom reports are invaluable." ',
                    user1: '- Juan Pérez, Investor',
                    user2: '- María López, Buyer',
                    user3: '- Carlos González, Yacht Seller',
                },
                faqstc: {
                    title: 'Frequently Asked Questions',
                    question1: 'What is Compralovendelo?',
                    question2: 'How does Compralovendelo work?',
                    question3: 'Is it safe to use Compralovendelo?',
                    answer1: 'Compralovendelo is an online directory for real estate, automobiles, and yachts, connecting buyers and sellers efficiently and securely.',
                    answer2: 'Our platform allows users to list their properties, search available options, and conduct secure transactions.',
                    answer3: 'Yes, we prioritize the safety of our users with listing verifications and secure transactions.'
                }
            },
            contact_us: {
                header: {
                    title: 'Contact Us',
                    description: 'If you have any questions, please do not hesitate to contact us. We are here to help.'
                },
                form: {
                    name: 'Name',
                    email: 'Email',
                    subject: 'Subject',
                    message: 'Message',
                    btn: 'Send'
                }
            },
            faq: {
                header: {
                    title: 'Frequently Asked Questions',
                    description: 'We are here to answer your questions.'
                },
                description: 'Discover the full range of features and services we offer and how to use them.',
                morequestion: 'Do you have more questions? Contact our support team with any inquiries you may have.',
                contact_us: 'Contact Us'
            }
        },
    }
}))